import { selector } from "recoil";
import { colorDbState, selTableIDState } from "./atoms";

export const currentColorTableSel = selector({
  key: "currentColorTable",
  get: ({ get }) => {
    const colorTables = get(colorDbState);
    if (!colorTables.length) return null;
    const selTableId = get(selTableIDState);
    return colorTables[selTableId];
  }
})
export const totalColorRowSel = selector({
  key: "totalColorRows",
  get: ({ get }) => {
    const colorTables = get(colorDbState);
    if (!colorTables) return 0;
    let count = 0;
    colorTables.forEach(table => {
      count += table.ColorRows.length
    })
    return count;
  }
})